import React, { createContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const AuthContext = createContext();

const isTokenExpired = (token) => {
  const decoded = jwtDecode(token);
  const now = Math.floor(Date.now() / 1000);
  return decoded.exp < now;
};

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      if (isTokenExpired(storedToken)) {
        localStorage.removeItem('token');
        navigate('/');
      } else {
        const decodedUser = jwtDecode(storedToken);
        setToken(storedToken);
        setUser(decodedUser);
      }
    }
  }, [navigate]);

  const login = (token) => {
    if (isTokenExpired(token)) {
      alert("Die Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.");
      logout();
      return;
    }
    const decodedUser = jwtDecode(token);
    setUser(decodedUser);
    setToken(token);
    localStorage.setItem('token', token);
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem('token');
    navigate('/');
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;